import React, { useState } from 'react';
import * as Routes from '@/modules/routes';
import SPAButton from './SPAButton';
import SPADialog from './SPADialog';

interface ImpersonateButtonProps {
  id: number | string;
  /** Overrides the trigger's text; the confirmation dialog stays the same. */
  label?: string;
  name: string | null;
  /** Where the masquerade lands instead of the user's home page. */
  toPath?: string | null;
  userType: 'staffer' | 'student';
}

const ImpersonateButton = ({
  id, label, name: fullName, toPath = null, userType,
}: ImpersonateButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const student = userType === 'student';
  const name = fullName || 'this user';
  // Ending the masquerade returns here, whichever mount (SPA or legacy page) this was opened on.
  const params = { return_path: window.location.href, ...(toPath != null && { to_path: toPath }) };
  const href = student ? Routes.student_masquerade_path(id, params) : Routes.staffer_masquerade_path(id, params);

  return (
    <SPADialog open={isOpen} onOpenChange={setIsOpen}>
      <SPADialog.Trigger asChild>
        <SPAButton className="tw-whitespace-nowrap" variant="outline">
          {label ?? (student ? 'Sign in as Student' : 'Sign in as Staff User')}
        </SPAButton>
      </SPADialog.Trigger>
      <SPADialog.Content size="sm">
        <SPADialog.Header>
          <SPADialog.Title>{student ? 'Sign in as a Student' : 'Sign in as Staff User'}</SPADialog.Title>
          <SPADialog.CloseButton />
        </SPADialog.Header>
        <SPADialog.Body className="tw-flex tw-flex-col tw-gap-3">
          <SPADialog.Description>
            By signing in as {name}, you are accessing their account and will see everything they see.
          </SPADialog.Description>
          <p className="tw-m-0 tw-text-sm tw-leading-5 tw-text-spa-warning">
            <strong>WARNING:</strong>
            {' '}
            any changes made while signed in as {name} will overwrite existing data.
          </p>
        </SPADialog.Body>
        <SPADialog.Footer>
          <SPADialog.Close asChild>
            <SPAButton>Cancel</SPAButton>
          </SPADialog.Close>
          <SPAButton asChild variant="primary">
            <a href={href}>Sign in</a>
          </SPAButton>
        </SPADialog.Footer>
      </SPADialog.Content>
    </SPADialog>
  );
};

export default ImpersonateButton;
